import { RowDataReducerAction } from "../../../../../types";

export const addEmptyEnum = (
  propertyKey: string,
  dispatch: React.Dispatch<RowDataReducerAction>,
): void => {
  dispatch({
    type: "UPDATE_SCHEMA_PROPERTY_FIELD",
    payload: {
      propertyKey,
      propertyField: "enum",
      newPropertyFieldValue: [],
    },
  });
};
